import { CreativePairFiles } from './modules/publisher/model';

export type Manager = {
  ads_manager: string;
  saved: boolean;
};

export type Creative = {
  video_base_title: string;
  sum_spend: number;
  sum_purchases: number;
  impressions: number;
  clicks: number;
  installs: number;
  IR: number;
  CTR: number;
  CR: number;
  CPM: number;
  CPI: number;
  roi_28: number;
  sum_purchase_conv_value_28: number;
  crhub_exists_flag: string;
  node_id: number | null;
};

export type CreativeGet = {
  crhub_project_id: string;
  report_date_from: string;
  report_date_to: string;
  order_by: string;
  ads_manager: undefined | string;
  filters: MarketingStatFilterBreakdown[];
  filters_metric: MarketingStatFilterMetric[];
  page_num: number;
  page_size: number;
  search_str?: string;
};
export type MarketingStatFilterMetric = {
  predicate: 'ge' | 'le';
  value: number;
  source_id: string;
};

export type MarketingStatFilterBreakdown = {
  source_id: string;
  values_in: string[];
  inversion: boolean;
};

export type ManagerSave = {
  ads_manager: string;
};

export type ManagerSaved = {
  ads_manager: string;
};

export type GraphicGet = {
  crhub_project_id: string;
  report_date_from: string;
  report_date_to: string;
  creative_name: string;
  filters: MarketingStatFilterBreakdown[];
  filters_metric: MarketingStatFilterMetric[];
};

export type Graphic = {
  report_date: string;
  sum_spend: number;
  roi_28: number;
};
export type CreativeTitle = {
  video_base_title: string;
};

export const NOT_APPLICABLE: unique symbol = Symbol('not applicable');
export type LocalizationValue = string;
export type LocalizationsFront = LocalizationValue[] | typeof NOT_APPLICABLE;
export type FormatValue = string;
export type FormatsFront = FormatValue[] | typeof NOT_APPLICABLE;

export function ensureLocValue(LV: LocalizationsFront): LocalizationValue[] {
  return LV === NOT_APPLICABLE ? [] : LV;
}

export function ensureValues(data: CreativePairFiles) {
  return {
    localizations: data.localizations === NOT_APPLICABLE ? [] : data.localizations,
    formats: data.formats === NOT_APPLICABLE ? [] : data.formats,
  };
}
